import dsBridge from "./dsbridge"
import IosBridge from './ios-bridge'
import { isInWX } from '@/utils/utils';
import { ViewQRcode } from '@/utils/wxApi'

export function checkIsAndroid() {
  const androidKeywords = ['Android', 'Linux'];
  return androidKeywords.some(item => navigator.userAgent.includes(item));
}

export function checkIsIOS() {
  return !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
}
// 是否鸿蒙
export function checkIsHarmony() {
  const harmonyKeywords = ['harmony'];
  return harmonyKeywords.some(item => navigator.userAgent.toLowerCase().includes(item));
}

const isAndroid = checkIsAndroid()
const isIOS = checkIsIOS()
const isHarmony = checkIsHarmony()

/**
 * 获取token
 * 支持设备：安卓、IOS、鸿蒙
 * 使用场景：App.vue
 */
export function getTokenFromApp() {
  return new Promise((resolve) => {
    if (isAndroid && window.android) {
      resolve(window.android.token())
    } else if (isIOS) {
      IosBridge.callhandler('iosToken', null, (token) => {
        resolve(token)
      })
    } else if (isHarmony) {
      dsBridge.call('token', data => {
        data = JSON.parse(data)
        resolve(data.token || '')
      })
    } else {
      resolve('')
    }
  })
}

/**
 * 扫一扫
 * 支持设备：安卓、IOS、鸿蒙
 */
export function scan(scanCallback, scanFail,complete ) {
  if (isInWX()) {
    ViewQRcode(scanCallback,scanFail, complete);
  } else if (isIOS) {
    IosBridge.callhandler('iosCodeScanning',null,scanCallback)
  } else if (isAndroid && window.android) {
    window.onScanCallBack = (res) => scanCallback(JSON.stringify(res))
    window.android.callNativeScan()
  } else if (isHarmony) {
    dsBridge.call('callNativeScan', null, (res) => {
      const result = JSON.parse(res)
      console.log(result.result, '鸿蒙扫一扫')
      scanCallback(result.result)
    })
  }
}

/**
 * 保存图片到相册
 * 支持设备：安卓、IOS、鸿蒙
 */
export function saveToAlbum(url) {
  if (isIOS) {
    IosBridge.callhandler('iosDownPhoto', {url}, null);
  } else if(isAndroid && window.android) {
    window.android.saveBase64ToAlbum(url.replace('data:image/jpeg;base64,', ''));
  } else if (isHarmony) {
    dsBridge.call('savePhoto', {base64: url}, ()=>{});
  }
}


export function requestLocation(callBack) {
  if (isAndroid && window.android) {
    window.onLocationCallBack = (longitude, latitude) => callBack({longitude, latitude})
    window.android.requestLocation();
  } else if (isIOS) {
    IosBridge.callhandler('iosMapLocation', null, (data) => {
      callBack(data);
    });
  } else if (isHarmony) {
    dsBridge.call('singleLocation', (data) => {
      data = JSON.parse(data)
      callback(data)
    })
  }
}
















